function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "X, Negative"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3269 1.90332H21.7003L14.3304 10.3266L23.0005 21.7889H16.2119L10.8948 14.8371L4.81085 21.7889H1.4354L9.31824 12.7792L1.00098 1.90332H7.96194L12.7681 8.25752L18.3269 1.90332ZM17.143 19.7697H19.0122L6.94625 3.81641H4.94036L17.143 19.7697Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2d3fd01d0c1619ae0474049c3dc5e819.svg";
export { ForwardRef as ReactComponent };